import ApiHelper from '@/services/ApiHelper'
import SweetAlert from '@/services/SweetAlert'

export default ({
  raceIdIncrement: 0,
  modules: {},
  state: {
    systems: [],
    system: {},
    status: null
  },
  mutations: {

    updatingSystemMutation (state, status) {
      state.status = status
    },

    fetchSystemsMutation (state, systems) {
      state.systems = systems
    },

    fetchSystemMutation (state, system) {
      state.system = system
    },

    addHorseMutation (state, data) {
      state.system.reduction_result = data.reduction_result
      state.system.game.race_list.find(x => x.leg_nr === data.horseDetails.leg_nr).horse_list.find(y => y.start_nr === data.horseDetails.start_nr).system_horse.selected = true
    },

    removeHorseMutation (state, data) {
      state.system.reduction_result = data.reduction_result
      state.system.game.race_list.find(x => x.leg_nr === data.horseDetails.leg_nr).horse_list.find(y => y.start_nr === data.horseDetails.start_nr).system_horse.selected = false
    },

    setHorseValueMutation (state, data) {
      if (data.details.selected) {
        state.system.reduction_result = data.reduction_result
      }
      if (data.details.rule === 'group') {
        if (data.details.set) {
          state.system.game.race_list.find(x => x.leg_nr === data.details.leg_nr).horse_list.find(y => y.start_nr === data.details.start_nr).system_horse.group_code_list.push(data.details.value)
        } else {
          const index = state.system.game.race_list.find(x => x.leg_nr === data.details.leg_nr).horse_list.find(y => y.start_nr === data.details.start_nr).system_horse.group_code_list.indexOf(data.details.value)
          state.system.game.race_list.find(x => x.leg_nr === data.details.leg_nr).horse_list.find(y => y.start_nr === data.details.start_nr).system_horse.group_code_list.splice(index, 1)
        }
      } else {
        state.system.game.race_list.find(x => x.leg_nr === data.details.leg_nr).horse_list.find(y => y.start_nr === data.details.start_nr).system_horse[data.details.type] = data.details.value
      }
    },

    setRuleValuesMutation (state, data) {
      state.system.reduction_result = data.reduction_result
      if (data.rule.rule === 'group') {
        const existingRule = state.system.reduction_rules.groups.find(x => x.group === data.rule.group)
        if (existingRule) {
          state.system.reduction_rules.groups[state.system.reduction_rules.groups.indexOf(existingRule)] = data.rule
        } else {
          state.system.reduction_rules.groups.push(data.rule)
        }
      } else {
        Object.assign(state.system.reduction_rules[data.rule.rule], data.rule)
      }
    },

    toggleSystemLockMutation (state, data) {
      if (data.locked) {
        state.system.reduction_result = data.reduction_result
      }
      state.system.locked = data.locked
    },

    removeGroupRuleMutation (state, data) {
      state.system.reduction_result = data.reduction_result
      const existingRule = state.system.reduction_rules.groups.find(x => x.group === data.rule.group)
      if (existingRule) {
        state.system.reduction_rules.groups.splice(state.system.reduction_rules.groups.indexOf(existingRule), 1)
      }
    },

    fetchResultsMutation (state, data) {
      state.system.game_result = data
    },

    fetchReductionResultMutation (state, data) {
      state.system.reduction_result = data
    },

    fetchGameMutation (state, data) {
      state.system.game = data
    },

    updateCouponSettingsMutation (state, data) {
      state.system.coupon_settings = data.coupon_settings
      state.system.reduction_result = data.reduction_result
    },

    updateReserveHandlingMutation (state, data) {
      state.system.reserv_handling = data.code
    },

    updateReservesMutation (state, data) {
      state.system.reserves[data.leg_nr] = data
    },

    fetchLiveDataMutation (state, liveData) {
      if (state.system) {
        liveData.RaceList.forEach((race) => {
          race.HorseList.forEach((horse) => {
            const horseItem = state.system.game.race_list.find(x => x.leg_nr === race.LegNr).horse_list.find(y => y.start_nr === horse.StartNr)
            if (horse.StakeDistributionShare && horse.StakeDistributionShare > 0.0) {
              horseItem.stake_distribution_share = Math.round(horse.StakeDistributionShare * 100)
            }
            if (horse.VinnarOdds && horse.VinnarOdds > 0) {
              horseItem.odds = horse.VinnarOdds
            }
            if (horse.Scratched !== null) {
              horseItem.cancelled = horse.Scratched
            }
          })
        })
      }
    }
  },

  actions: {
    createSystemAction ({ commit }, systemDetails) {
      return new Promise((resolve, reject) => {
        ApiHelper.createSystem(systemDetails)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
            SweetAlert.failedOperation(error)
          })
      })
    },
    fetchSystemsAction ({ commit }, systemsParams) {
      return new Promise((resolve, reject) => {
        ApiHelper.fetchSystems(systemsParams)
          .then(response => {
            const systems = response.systems
            commit('fetchSystemsMutation', systems)
            resolve(response)
          })
          .catch(error => {
            reject(error)
            SweetAlert.failedOperation(error)
          })
      })
    },
    fetchSystemAction ({ commit }, id) {
      return new Promise((resolve, reject) => {
        ApiHelper.fetchSystem(id)
          .then(response => {
            const system = response.system
            commit('fetchSystemMutation', system)
            resolve(response)
          })
          .catch(error => {
            reject(error)
            SweetAlert.failedOperation(error)
          })
      })
    },
    addHorseAction ({ commit }, horseDetails) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.addHorse(horseDetails)
          .then(response => {
            const data = { horseDetails: horseDetails, reduction_result: response.system }
            commit('addHorseMutation', data)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    removeHorseAction ({ commit }, horseDetails) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.removeHorse(horseDetails)
          .then(response => {
            const data = { horseDetails: horseDetails, reduction_result: response.system }
            commit('removeHorseMutation', data)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    setHorseValueAction  ({ commit }, details) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.setHorseValue(details)
          .then(response => {
            const data = { details: details, reduction_result: response.system }
            commit('setHorseValueMutation', data)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    setRuleValuesAction  ({ commit }, rule) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.setRuleValues(rule)
          .then(response => {
            const data = { rule: rule, reduction_result: response.system }
            commit('setRuleValuesMutation', data)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    lockSystemAction  ({ commit }, id) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.lockSystem(id)
          .then(response => {
            const data = { reduction_result: response.system, locked: true }
            commit('toggleSystemLockMutation', data)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    unlockSystemAction  ({ commit }, id) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.unlockSystem(id)
          .then(response => {
            const data = { reduction_result: response.system, locked: false }
            commit('toggleSystemLockMutation', data)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    removeGroupRuleAction  ({ commit }, rule) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.removeGroupRule(rule)
          .then(response => {
            const data = { reduction_result: response.system, rule: rule }
            commit('removeGroupRuleMutation', data)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    fetchResultsAction  ({ commit }, id) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.fetchResults(id)
          .then(response => {
            commit('fetchResultsMutation', response.system)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    fetchReductionResultAction  ({ commit }, id) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.fetchReductionResult(id)
          .then(response => {
            commit('fetchReductionResultMutation', response.system)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    fetchGameAction  ({ commit }, details) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.fetchGame(details)
          .then(response => {
            commit('fetchGameMutation', response.game)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    updateCouponSettingsAction ({ commit }, couponSettings) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.updateCouponSettings(couponSettings)
          .then(response => {
            const data = { reduction_result: response.system, coupon_settings: couponSettings }
            commit('updateCouponSettingsMutation', data)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    updateReserveHandlingAction ({ commit }, details) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.updateReserveHandling(details)
          .then(response => {
            commit('updateReserveHandlingMutation', details.code)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    updateReservesAction ({ commit }, reserves) {
      commit('updatingSystemMutation', true)
      return new Promise((resolve, reject) => {
        ApiHelper.updateReserves(reserves)
          .then(response => {
            commit('updateReservesMutation', reserves)
            resolve(response)
            commit('updatingSystemMutation', false)
          })
          .catch(error => {
            reject(error)
            commit('updatingSystemMutation', false)
            SweetAlert.failedOperation(error)
          })
      })
    },

    fetchLiveDataAction ({ commit }, gameDetails) {
      return new Promise((resolve, reject) => {
        ApiHelper.fetchLiveData(gameDetails)
          .then(response => {
            const liveData = response.live_data
            commit('fetchLiveDataMutation', liveData)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
})
